import { performLogout } from "../auth/performLogout";

export const SESSION_EXPIRED_EVENT = "carepro:session-expired";
export const LOGOUT_STORAGE_KEY = "carepro:logout-trigger";

const normalizeMessage = (message?: string): string => {
  const trimmed = (message || "").trim();
  if (!trimmed) return "Session expired. Please login again.";
  return trimmed;
};

/**
 * Force logout when session expires (API refresh failed, etc.).
 */
export const forceSessionLogout = (message?: string): void => {
  const reason = normalizeMessage(message);

  void performLogout({
    callLogoutApi: false,
    showToast: true,
    toastMessage: reason,
  }).then(() => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent(SESSION_EXPIRED_EVENT, {
          detail: { message: reason },
        })
      );
      window.location.href = "/";
    }
  });
};
